module.exports = __webpack_public_path__ + "static/media/inr_santa.c732ffdd.glb";